import { GetEmailCycleNamesRPC } from "@pulse/pulse-rpcs/lib/email-cycle/getEmailCycleNamesRPC";
import { GetEmailCycleNamesRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/getEmailCycleNamesRPCClientImpl";
import { GetEmailCyclesRPC } from "@pulse/pulse-rpcs/lib/email-cycle/getEmailCyclesRPC";
import { GetEmailCyclesRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/getEmailCyclesRPCClientImpl";
import { MOCK } from "@pulse/shared-components";
import { APIClient } from "@surya-digital/tedwig";
import { MockGetEmailCycleNamesRPCClientImpl } from "./MockGetEmailCycleNamesRPCClientImpl";
import { MockGetEmailCyclesRPCClientImpl } from "./MockGetEmailCyclesRPCClientImpl";
import { AssignEmailCycleRPC } from "@pulse/pulse-rpcs/lib/email-cycle/assignEmailCycleRPC";
import { AssignEmailCycleRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/assignEmailCycleRPCClientImpl";
import { MockAssignEmailCycleRPCClientImpl } from "./MockAssignEmailCycleRPCClientImpl";
import { CreateEmailCycleRPC } from "@pulse/pulse-rpcs/lib/email-cycle/createEmailCycleRPC";
import { CreateEmailCycleRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/createEmailCycleRPCClientImpl";
import { MockCreateEmailCycleRPCClientImpl } from "./MockCreateEmailCycleRPCClientImpl";
import { GetEmailCycleDetailsRPC } from "@pulse/pulse-rpcs/lib/email-cycle/getEmailCycleDetailsRPC";
import { GetEmailCycleDetailsRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/getEmailCycleDetailsRPCClientImpl";
import { MockGetEmailCycleDetailsRPCClientImpl } from "./MockGetEmailCycleDetailsRPCClientImpl";
import { UpdateEmailCycleRPC } from "@pulse/pulse-rpcs/lib/email-cycle/updateEmailCycleRPC";
import { UpdateEmailCycleRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/updateEmailCycleRPCClientImpl";
import { MockUpdateEmailCycleRPCClientImpl } from "./MockUpdateEmailCycleRPCClientImpl";
import { DeleteEmailCycleRPC } from "@pulse/pulse-rpcs/lib/email-cycle/deleteEmailCycleRPC";
import { DeleteEmailCycleRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/deleteEmailCycleRPCClientImpl";
import { MockDeleteEmailCycleRPCClientImpl } from "./MockDeleteEmailCycleRPCClientImpl";
import { StopEmailCycleRPC } from "@pulse/pulse-rpcs/lib/email-cycle/stopEmailCycleRPC";
import { StopEmailCycleRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/stopEmailCycleRPCClientImpl";
import { MockStopEmailCycleRPCClientImpl } from "./MockStopEmailCycleRPCClientImpl";
import { GetEmailCycleRecipientsRPC } from "@pulse/pulse-rpcs/lib/email-cycle/getEmailCycleRecipientsRPC";
import { GetEmailCycleRecipientsRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/getEmailCycleRecipientsRPCClientImpl";
import { MockGetEmailCycleRecipientsRPCClientImpl } from "./MockGetEmailCycleRecipientsRPCClientImpl";
import { RemoveEmailCycleRecipientRPC } from "@pulse/pulse-rpcs/lib/email-cycle/removeEmailCycleRecipientRPC";
import { RemoveEmailCycleRecipientRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/removeEmailCycleRecipientRPCClientImpl";
import { MockRemoveEmailCycleRecipientRPCClientImpl } from "./MockRemoveEmailCycleRecipientRPCClientImpl";
import { PreviewEmailRPC } from "@pulse/pulse-rpcs/lib/email-cycle/previewEmailRPC";
import { PreviewEmailRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/previewEmailRPCClientImpl";
import { MockPreviewEmailRPCClientImpl } from "./MockPreviewEmailRPCClientImpl";
import { GetInvestigationSummaryRPC } from "@pulse/pulse-rpcs/lib/email-cycle/getInvestigationSummaryRPC";
import { GetInvestigationSummaryRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/getInvestigationSummaryRPCClientImpl";
import { MockGetInvestigationSummaryRPCClientImpl } from "./MockGetInvestigationSummaryRPCClientImpl";
import { ResendEmailRPC } from "@pulse/pulse-rpcs/lib/email-cycle/resendEmailRPC";
import { ResendEmailRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/resendEmailRPCClientImpl";
import { MockResendEmailRPCClientImpl } from "./MockResendEmailRPCClientImpl";
import { GetDeliveryStatsForProjectRPC } from "@pulse/pulse-rpcs/lib/email-cycle/getDeliveryStatsForProjectRPC";
import { GetDeliveryStatsForProjectRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/getDeliveryStatsForProjectRPCClientImpl";
import { MockGetDeliveryStatsForProjectRPCClientImpl } from "./MockGetDeliveryStatsForProjectRPCClientImpl";
import { GetPresignedDownloadURLForStatsRPC } from "@pulse/pulse-rpcs/lib/email-cycle/getPresignedDownloadUrlForStatsRPC";
import { GetPresignedDownloadURLForStatsRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/getPresignedDownloadUrlForStatsRPCClientImpl";
import { MockGetPresignedDownloadURLForStatsRPCClientImpl } from "./MockGetPresignedDownloadURLForStatsRPCClientImpl";
import { GetPresignedDownloadURLForEmailCycleRecipientsRPC } from "@pulse/pulse-rpcs/lib/email-cycle/getPresignedDownloadUrlForEmailCycleRecipientsRPC";
import { GetPresignedDownloadURLForEmailCycleRecipientsRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/getPresignedDownloadUrlForEmailCycleRecipientsRPCClientImpl";
import { MockGetPresignedDownloadURLForEmailCycleRecipientsRPCClientImpl } from "./MockGetPresignedDownloadURLForEmailCycleRecipientsRPCClientImpl";
import { GetOptOutScreenDetailsRPC } from "@pulse/pulse-rpcs/lib/email-cycle/getOptOutScreenDetailsRPC";
import { GetOptOutScreenDetailsRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/getOptOutScreenDetailsRPCClientImpl";
import { MockGetOptOutScreenDetailsRPCClientImpl } from "./MockGetOptOutScreenDetailsRPCClientImpl";
import { OptOutOfCampaignRPC } from "@pulse/pulse-rpcs/lib/email-cycle/optOutOfCampaignRPC";
import { OptOutOfCampaignRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/optOutOfCampaignRPCClientImpl";
import { MockOptOutOfCampaignRPCClientImpl } from "./MockOptOutOfCampaignRPCClientImpl";
import { GetCustomPlaceholdersRPC } from "@pulse/pulse-rpcs/lib/email-cycle/getCustomPlaceholdersRPC";
import { GetCustomPlaceholdersRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/getCustomPlaceholdersRPCClientImpl";
import { MockGetCustomPlaceholdersRPCClientImpl } from "./MockGetCustomPlaceholdersRPCClientImpl";

export const useGetEmailCycleNamesRPCClientImpl = (
  apiClient: APIClient,
): GetEmailCycleNamesRPC =>
  MOCK.emailCycles
    ? new MockGetEmailCycleNamesRPCClientImpl()
    : new GetEmailCycleNamesRPCClientImpl(apiClient);

export const useAssignEmailCycleRPCClientImpl = (
  apiClient: APIClient,
): AssignEmailCycleRPC =>
  MOCK.emailCycles
    ? new MockAssignEmailCycleRPCClientImpl()
    : new AssignEmailCycleRPCClientImpl(apiClient);

export const useCreateEmailCycleRPCClientImpl = (
  apiClient: APIClient,
): CreateEmailCycleRPC =>
  MOCK.emailCycles
    ? new MockCreateEmailCycleRPCClientImpl()
    : new CreateEmailCycleRPCClientImpl(apiClient);

export const useGetEmailCyclesRPCClientImpl = (
  apiClient: APIClient,
): GetEmailCyclesRPC =>
  MOCK.emailCycles
    ? new MockGetEmailCyclesRPCClientImpl()
    : new GetEmailCyclesRPCClientImpl(apiClient);

export const useGetEmailCycleDetailsRPCClientImpl = (
  apiClient: APIClient,
): GetEmailCycleDetailsRPC =>
  MOCK.emailCycles
    ? new MockGetEmailCycleDetailsRPCClientImpl()
    : new GetEmailCycleDetailsRPCClientImpl(apiClient);

export const useUpdateEmailCycleRPCClientImpl = (
  apiClient: APIClient,
): UpdateEmailCycleRPC =>
  MOCK.emailCycles
    ? new MockUpdateEmailCycleRPCClientImpl()
    : new UpdateEmailCycleRPCClientImpl(apiClient);

export const useDeleteEmailCycleRPCClientImpl = (
  apiClient: APIClient,
): DeleteEmailCycleRPC =>
  MOCK.emailCycles
    ? new MockDeleteEmailCycleRPCClientImpl()
    : new DeleteEmailCycleRPCClientImpl(apiClient);

export const useStopEmailCycleRPCClientImpl = (
  apiClient: APIClient,
): StopEmailCycleRPC =>
  MOCK.emailCycles
    ? new MockStopEmailCycleRPCClientImpl()
    : new StopEmailCycleRPCClientImpl(apiClient);

export const useGetEmailCycleRecipientsRPCClientImpl = (
  apiClient: APIClient,
): GetEmailCycleRecipientsRPC =>
  MOCK.emailCycles
    ? new MockGetEmailCycleRecipientsRPCClientImpl()
    : new GetEmailCycleRecipientsRPCClientImpl(apiClient);

export const useRemoveEmailCycleRecipientRPCClientImpl = (
  apiClient: APIClient,
): RemoveEmailCycleRecipientRPC =>
  MOCK.emailCycles
    ? new MockRemoveEmailCycleRecipientRPCClientImpl()
    : new RemoveEmailCycleRecipientRPCClientImpl(apiClient);

export const usePreviewEmailRPCClientImpl = (
  apiClient: APIClient,
): PreviewEmailRPC =>
  MOCK.emailCycles
    ? new MockPreviewEmailRPCClientImpl()
    : new PreviewEmailRPCClientImpl(apiClient);

export const useGetInvestigationSummaryRPCClientImpl = (
  apiClient: APIClient,
): GetInvestigationSummaryRPC =>
  MOCK.emailCycles
    ? new MockGetInvestigationSummaryRPCClientImpl()
    : new GetInvestigationSummaryRPCClientImpl(apiClient);

export const useResendEmailRPCClientImpl = (
  apiClient: APIClient,
): ResendEmailRPC =>
  MOCK.emailCycles
    ? new MockResendEmailRPCClientImpl()
    : new ResendEmailRPCClientImpl(apiClient);

export const useGetDeliveryStatsForProjectRPCClientImpl = (
  apiClient: APIClient,
): GetDeliveryStatsForProjectRPC =>
  MOCK.emailCycles
    ? new MockGetDeliveryStatsForProjectRPCClientImpl()
    : new GetDeliveryStatsForProjectRPCClientImpl(apiClient);

export const useGetPresignedDownloadURLForStatsRPCClientImpl = (
  apiClient: APIClient,
): GetPresignedDownloadURLForStatsRPC =>
  MOCK.emailCycles
    ? new MockGetPresignedDownloadURLForStatsRPCClientImpl()
    : new GetPresignedDownloadURLForStatsRPCClientImpl(apiClient);

export const useGetPresignedDownloadURLForEmailCycleRecipientsRPCClientImpl = (
  apiClient: APIClient,
): GetPresignedDownloadURLForEmailCycleRecipientsRPC =>
  MOCK.emailCycles
    ? new MockGetPresignedDownloadURLForEmailCycleRecipientsRPCClientImpl()
    : new GetPresignedDownloadURLForEmailCycleRecipientsRPCClientImpl(
        apiClient,
      );

export const useGetOptOutScreenDetailsRPCClientImpl = (
  apiClient: APIClient,
): GetOptOutScreenDetailsRPC =>
  MOCK.emailCycles
    ? new MockGetOptOutScreenDetailsRPCClientImpl()
    : new GetOptOutScreenDetailsRPCClientImpl(apiClient);

export const useOptOutOfCampaignRPCClientImpl = (
  apiClient: APIClient,
): OptOutOfCampaignRPC =>
  MOCK.emailCycles
    ? new MockOptOutOfCampaignRPCClientImpl()
    : new OptOutOfCampaignRPCClientImpl(apiClient);

export const useGetCustomPlaceholdersRPCClientImpl = (
  apiClient: APIClient,
): GetCustomPlaceholdersRPC =>
  MOCK.emailCycles
    ? new MockGetCustomPlaceholdersRPCClientImpl()
    : new GetCustomPlaceholdersRPCClientImpl(apiClient);
